import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './Popup.less'
import Mask from './Mask'
import PopupHeader from './PopupHeader'
import Dialog from "./Dialog"

class Popup extends Component {
    static Header = PopupHeader
    static propTypes = {
        show: PropTypes.bool,
        header: PropTypes.oneOfType([PropTypes.bool, PropTypes.object, PropTypes.func]),
        title: PropTypes.string,
        onCancel: PropTypes.func // 用户点击阴影取消时触发
    }

    static defaultProps = {
        show: false,
        header: false,
        title: ''
    }

    constructor(props) {
        super(props)
        this.state = {
            visible: props.show,
            isClosing: false
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.show) {
            this.setState({ visible: true, isClosing: false })
        } else {
            if (this.props.show && this.state.visible) {
                this.handleCancel()
            } else {
                this.setState({ visible: false, isClosing: false })
            }
        }
    }

    componentDidUpdate(newProps) {
        if (newProps.show) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = ''
        }
    }

    componentWillUnmount() {
        document.body.style.overflow = ''
    }

    handleClose = (e, cb) => {
        e && e.stopPropagation()
        this.setState({ isClosing: true }, () => setTimeout(() => {
            this.setState({ isClosing: false, visible: false }, () => cb && cb())
        }, 300))
    }

    handleCancel = (e) => {
        this.handleClose(e, () => this.props.onCancel && this.props.onCancel(e))
    }

    renderHeaderOrFooter = () => {
        const { children, header, footer, title } = this.props
        let newChildren = children
        if (header || footer) {
            let defaultHeader, defaultFooter
            const content = <div key='popup_content' className={styles['popup-content']}>{children}</div>
            if (header) {
                // 使用PopupHeader控件，则拦截取消和确定事件
                // 避免在取消或者确定后直接remove Popup控件或者remove其父级dom导致不会出现下滑动画的情况 影响用户体验
                const event = {
                    onCancel: e => this.handleClose(e, () => this.props.onCancel && this.props.onCancel(e))
                }
                if (header === true) { // 如果设置 header=true 则添加默认的header
                    defaultHeader = <Popup.Header key='popup_header' {...event} title={title} />
                } else {
                    defaultHeader = typeof header === 'function' ? header({ ...event, title }) : React.cloneElement(header, { ...event })
                }
            }
            if (footer) {
                // 使用PopupHeader控件，则拦截取消和确定事件
                // 避免在取消或者确定后直接remove Popup控件或者remove其父级dom导致不会出现下滑动画的情况 影响用户体验
                const event = {
                    onClearExit: e => this.handleClose(e, () => this.props.onClearExit && this.props.onClearExit(e)),
                    onConfirm: e => this.handleClose(e, () => this.props.onConfirm && this.props.onConfirm(e))
                }
                defaultFooter = typeof footer === 'function' ? footer({ ...event, mustInput: this.props.mustInput }) : React.cloneElement(footer, { ...event })
            }
            newChildren = [defaultHeader].concat(content).concat([defaultFooter])
        }
        return newChildren
    }

    render() {
        const { show, className, children, onConfirm, onCancel, header, title, footer, ...others } = this.props

        const cls = classNames(styles.popup, {
            [styles['popup-slide-up']]: show && !this.state.isClosing,
            [styles['popup-slide-down']]: this.state.isClosing
        }, className)

        const maskCls = classNames({
            [styles['popup-mask-fade-in']]: show && !this.state.isClosing,
            [styles['popup-mask-fade-out']]: this.state.isClosing
        })

        return (this.state.visible || this.state.isClosing) ? (
            <>
                <div className={styles['popup-wrapper']}>
                    <Mask className={maskCls} onClick={this.handleCancel} />
                    <div className={cls} {...others} key="popup12138" >
                        {this.renderHeaderOrFooter()}
                    </div>
                </div>
            </>
        ) : false
    }
}

export default Popup
